import { render, staticRenderFns } from "./Breadcrum.vue?vue&type=template&id=3dd4cb20&scoped=true&"
import script from "./Breadcrum.vue?vue&type=script&lang=ts&"
export * from "./Breadcrum.vue?vue&type=script&lang=ts&"
import style0 from "./Breadcrum.vue?vue&type=style&index=0&id=3dd4cb20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd4cb20",
  null
  
)

export default component.exports